/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa formsLanding
 *
 */
Intesa.FormsLanding = function () {
	
	var formLanding = this;

	var isCaptcha = $(".com07-1__formContainer").find(".g-recaptcha-response").length > 0 ? false : true;
	
	var isLanding = $(".com07-1").length > 0;
	
	var isRc = $("#rc").length > 0;

	var submitInsideFormOffsetTop = $(".leaveMessage__submitWrapper").length > 0 ? $(".leaveMessage__submitWrapper").offset().top : null ;
	
	this.init = function (){
		
		console.log("Forms Landing");
      
        if($("html").attr("data-bank") !== "CIB" || !$(".js-landing__form").length){
          return;
   		}

		formLanding.setLandingRc();
		
		formLanding.updateRc();

		formLanding.stickySubmit();

		
	};

	this.recaptchaCallback = function () {
		console.log("Captcha Verified");
		isCaptcha = true;
		window.checkValidFormCaptcha();
	}

	this.validationCallback = function () {
		setTimeout(function () {
			console.log("Captcha Verified");
			isCaptcha = true;
			window.checkValidFormCaptcha();
		}, 500);
	}

	window.recaptchaCallback = $("input[name='recaptchaKey']").length >= 1 ? this.validationCallback : this.recaptchaCallback;

	
	this.setLandingRc = function (){
		
		if (isLanding && isRc){
			
			var rcValue = formLanding.findGetParameter("rc");
			
			if(rcValue != null && rcValue != '' && rcValue != undefined){
				
				// rc.val(rcValue);
				
				$("input[name='rc']").each(function (){
					
					$(this).val(rcValue);
					
					if($(this).hasClass("fc-primary")){
						
						$(this).addClass("fc-edited");
						
					}

				});
				
			}
			
		}else {

		}
		
	}
	
	
	this.findGetParameter = function(parameterName) {
	    var result = null,
	        tmp = [];
	    location.search
	        .substr(1)
	        .split("&")
	        .forEach(function (item) {
	          tmp = item.split("=");
	          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
	        });
	    return result;
	};
	
	
	this.updateRc = function (){
		
		$("input[name='rc']").on("change", function(){ 
			
			var newRc = $(this).val();
			
			$("input[name='rc']").each(function (){
				
				$(this).val(newRc);

			});
		});

	}


	this.stickySubmit = function () {

		/*Check if exists the submit inside the form*/
		var form = $(".com07-1__formContainer.new__form__container.js-landing__form");
		var checkSubmitInsideTheForm = form.find(".leaveMessage__submitWrapper button").length > 0;
		var checkSubmitOutsidetheForm = $(".com07_submit_button").length > 0;
		if (checkSubmitInsideTheForm && checkSubmitOutsidetheForm){
			/*Remove hide from fixed button*/
			formLanding.replaceSubmitLabel();
			formLanding.activeSubmitButton();
			formLanding.checkScrollSubmit();
			formLanding.stickyButtonSubmit();
		}else{
			formLanding.enableSubmitFormButton();
		}

	}


	this.enableSubmitFormButton = function () {

	//if is used the old form the logic to disable the submit button is removed.
	
	var hasDisabled = $(".typeLandingPage").find(".leaveMessage__submit").hasClass("disabled");

	if(hasDisabled){

		$(".typeLandingPage").find(".leaveMessage__submit").removeClass("disabled");

	}
	
	}


	this.activeSubmitButton = function (){

	var form = $(".com07-1__formContainer.new__form__container.js-landing__form");

	var fixedButton = $(".com07_submit_button");

	var formButton = $(form).find(".leaveMessage__submit");

	$(form.find("input , select")).each(function () {

		$(this).on("input", function(){

			var formInside = $(this).closest("form");

			console.log("isCaptcha -> ", isCaptcha);

			console.log(isCaptcha);

			if(formInside.parsley().isValid() &&  isCaptcha ){

				if(fixedButton.hasClass("disabled")){

					fixedButton.removeClass("disabled");

				}

				if(formButton.hasClass("disabled")){

					formButton.removeClass("disabled");

				}

			}else{

				if(!fixedButton.hasClass("disabled")){

					fixedButton.addClass("disabled");

				}

				if(!formButton.hasClass("disabled")){

					formButton.addClass("disabled");

				}

			}

		});

	});

}


	window.checkValidFormCaptcha = function () {

		var form = $(".com07-1__formContainer.new__form__container.js-landing__form");

		var fixedButton = $(".com07_submit_button");

		var formButton = $(form).find(".leaveMessage__submit");

		if(form.length > 0){

			if(form.parsley().isValid() &&  isCaptcha ){

				if(fixedButton.hasClass("disabled")){
	
					fixedButton.removeClass("disabled");
	
				}
	
				if(formButton.hasClass("disabled")){
	
					formButton.removeClass("disabled");
	
				}
	
			}else{
	
				if(!fixedButton.hasClass("disabled")){
	
					fixedButton.addClass("disabled");
	
				}
	
				if(!formButton.hasClass("disabled")){
	
					formButton.addClass("disabled");
	
				}
	
			}
		}

	}

	


	this.replaceSubmitLabel = function () {

		var buttonFormText = $(".com07-1__formContainer.new__form__container.js-landing__form").find(".leaveMessage__submitWrapper button").text();

		$(".com07_submit_button").text(buttonFormText);

		formLanding.checksIfButtonShouldBeVisibile();

	}


	this.checksIfButtonShouldBeVisibile = function (){


		$(".com07_button").css('left', '9990px');

		$(".com07_button").removeClass("hide");

		var submitOutsideFromOffsetTop = $(".com07_button").offset().top;

		if(submitOutsideFromOffsetTop < submitInsideFormOffsetTop){

			$(".com07_button").css('left', '');

		}

	}


	this.checkScrollSubmit = function () {

	var checkIsVisible = false;

	$(document).on("scroll", function () {

		var submitOutsideFromOffsetTop;

		submitOutsideFromOffsetTop = $(".com07_button").offset().top;

		if($(".com07_button").css('left') != "9990px"){

			checkIsVisible = true;

		}else {

			checkIsVisible = false;

		}

		if(submitOutsideFromOffsetTop >= submitInsideFormOffsetTop){

			if(checkIsVisible){

				
				$(".com07_button").css('left', '9990px');

			}

		}else{

			if(!checkIsVisible){

				$(".com07_button").css('left', '');


			}
			
		}

	});


	}


	this.stickyButtonSubmit = function(){

		var button = $(".com07_submit_button");

		button.on("click", function () {

		var buttonForm = $(".com07-1__formContainer.new__form__container.js-landing__form").find(".leaveMessage__submitWrapper button");

		$(buttonForm).click();

		});

	}

	

};






/**
 * Get class instance
 *
 */
Intesa.FormsLanding.getInstance = function () {

	if (!window.intesa) {

		window.intesa = new Object();

	}
	if (!window.intesa.formsLanding) {

		window.intesa.formsLanding = new Intesa.FormsLanding();

	}

	return window.intesa.formsLanding;

};
